import React, { useEffect, useState } from 'react';
import {
  InputSelect,
  InputSummernote,
  InputText
} from '../../components/inputs';
import { API_HOST } from '../../consts';
import Axios from 'axios';
import InputCheckBox from './InputCheckBox';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ModalBody, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import {
  Document,
  SubTitle,
  Paragraph,
  UnorderedList,
  FormContainer,
  DivSelectForm,
  DivFather,
  DivConteiner,
  DivBody,
  DivCheckbox,
  DivHeaderForm,
  SpanTitle,
  HorizontalLine,
  DivGenero,
  DivButtonDelete,
  DivButtonPreVisualizar,
  ButtonPreVisualizar,
  DivButton,
  ButtonCancelar,
  ButtonDelete,
  DivButtonSalvar,
  ButtonPadrao,
  ButtonGerar
} from './styles/CreateRedacaoStyles';
import InputNumber from '../../components/inputs/InputNumber';

const CreateRedacaoIA = () => {
  const [formData, setFormData] = useState({
    periodo: [],
    periodoSelecionado: {},
    tipoOption: [],
    tipoSelecionado: {},
    genero: [],
    generoSelecionado: {},
    criterios: [],
    criteriosSelecionados: [],
    instrucoes: [],
    instrucoesSelecionadas: [],
    textoMotivador: [],
    proposta_de_texto: '',
    nome: '',
    isTemaRedacaoEnabled: false,
    isModalOpen: false,
    numeroTextosMotivadores: [
      { value: 1, label: '1' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' }
    ],
    numeroTextosMotivadoresSelecionado: {},
    numeroMinimoCaracteres: 0,
    fetchGerandoTema: false,
    temaGerado: false
  });

  const fetchData = async () => {
    try {
      const [periodoRes, tipoRes, criteriosRes, instrucoesRes] =
        await Promise.all([
          Axios.get(`${API_HOST}/core/periodo`),
          Axios.get(`${API_HOST}/redacao_temas/tipos`),
          Axios.get(`${API_HOST}/redacao_temas/criterios`),
          Axios.get(`${API_HOST}/redacao_temas/instrucoes`)
        ]);
      setFormData((prevData) => ({
        ...prevData,
        periodo: periodoRes.data
          .filter((x) => x.nivel_id !== 1 && x.nivel_id !== 6)
          .map((x) => ({ value: x.id, label: x.descricao })),
        tipoOption: tipoRes.data.map((x) => ({ value: x.id, label: x.nome })),
        criterios: criteriosRes.data.map((x) => ({
          value: x.id,
          label: x.nome
        })),
        instrucoes: instrucoesRes.data.map((x) => ({
          value: x.id,
          label: x.nome
        }))
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchGenero = async (e) => {
    if (e.value) {
      try {
        const params = {
          tipo: e.value
        };
        const res = await Axios.get(`${API_HOST}/redacao_temas/generos`, {
          params
        });
        setFormData((prevState) => ({
          ...prevState,
          genero: res.data.map((x) => ({
            value: x.id,
            label: x.nome
          }))
        }));
      } catch (err) {
        console.error(err);
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        genero: []
      }));
    }
  };

  const PostTema = async () => {
    try {
      const params = {
        nome: formData.nome,
        periodo: formData.periodoSelecionado.value,
        genero: formData.generoSelecionado.value,
        tipo: formData.tipoSelecionado.value,
        instrucoes: formData.instrucoesSelecionadas,
        criterios: formData.criteriosSelecionados,
        ...criaObjTextosMotivadores(),
        proposta_de_texto: formData.proposta_de_texto
      };
      await Axios.post(`${API_HOST}/redacao_temas/temas`, params);
      window.location.href = `/redacao/temas-redacoes`;
    } catch (err) {
      console.error(err);
    }
  };

  const GetTemaIA = async () => {
    if (
      formData.periodoSelecionado.value &&
      formData.tipoSelecionado.value &&
      formData.generoSelecionado.value &&
      formData.numeroTextosMotivadoresSelecionado.value
    ) {
      try {
        setFormData((prevState) => ({
          ...prevState,
          fetchGerandoTema: true
        }));
        const params = {
          nome: formData.nome,
          periodo: formData.periodoSelecionado.label,
          tipo: formData.tipoSelecionado.label,
          genero: formData.generoSelecionado.label,
          numero_textos_motivadores:
            formData.numeroTextosMotivadoresSelecionado.value,
          numero_minimo_caracteres: parseInt(formData.numeroMinimoCaracteres)
        };
        const response = await Axios.post(
          `${API_HOST}/redacao_temas/temas/gerar_tema_por_ia`,
          params
        );
        const data = response.data;
        setFormData((prevState) => ({
          ...prevState,
          isTemaRedacaoEnabled: true,
          proposta_de_texto: `<p>${data.propostaRedacao}</p>`,
          nome: data.tema,
          temaGerado: true,
          textoMotivador: data.textosMotivadores.map((elemen, index) => ({
            id: index,
            active: true,
            texto: `<p>${elemen.texto}</p> <p>REFERÊNCIA: ${elemen.referenciaBibliografica}</p>`
          }))
        }));
      } catch (err) {
        toast.error('Não foi possível gerar o tema, tente novamente');
        console.error(err);
      } finally {
        setFormData((prevState) => ({
          ...prevState,
          fetchGerandoTema: false
        }));
      }
    } else {
      toast.error('Preencha todos os campos para gerar o tema');
    }
  };

  useEffect(() => {
    fetchData();
    setFormData((prevState) => ({
      ...prevState,
      periodoSelecionado: {},
      tipoSelecionado: {},
      generoSelecionado: {},
      instrucoesSelecionadas: [],
      criteriosSelecionados: [],
      nome: null,
      proposta_de_texto: null
    }));
  }, []);

  const criaObjTextosMotivadores = () => {
    const obj = {};
    formData.textoMotivador.forEach((texto, index) => {
      obj[`texto_motivador_${index + 1}`] = texto.texto;
    });
    return obj;
  };

  const handleAddTextoMotivador = () => {
    setFormData((prevState) => ({
      ...prevState,
      textoMotivador: [
        ...prevState.textoMotivador,
        { id: prevState.textoMotivador.length, active: true }
      ]
    }));
  };

  const handleDeleteTextoMotivador = (idToRemove) => {
    setFormData((prevState) => {
      const textosFiltrados = prevState.textoMotivador.filter(
        (texto) => texto.id !== idToRemove
      );
      return {
        ...prevState,
        textoMotivador: textosFiltrados
      };
    });
  };

  const handleCriarTema = () => {
    PostTema();
  };

  const handleGerarTema = () => {
    GetTemaIA();
  };

  const handleCancel = () => {
    window.location.href = `/redacao/temas-redacoes`;
  };

  const handleGenero = () => {
    if (!formData.tipoSelecionado.value) {
      toast.warn('Selecione o Tipo antes de selecionar o Genero');
    }
  };

  const handleChangeInputs = (e, field) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: e
    }));
  };

  const handleChangeInputCheckbox = (value, field) => {
    const index = formData[field].findIndex((item) => item === value);
    if (index !== -1) {
      setFormData((prevState) => ({
        ...prevState,
        [field]: prevState[field].filter((item) => item !== value)
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [field]: [...prevState[field], value]
      }));
    }
  };

  const handleChangeTextoMotivador = (e, id) => {
    setFormData((prevState) => ({
      ...prevState,
      textoMotivador: prevState.textoMotivador.map((texto) =>
        texto.id === id ? { ...texto, texto: e } : texto
      )
    }));
  };

  const createModal = () => {
    return (
      <Modal
        isOpen={formData.isModalOpen}
        size="lg"
        style={{ marginTop: '100px' }}
      >
        <ModalHeader className="header">
          PRÉ-VISUALIZAÇÃO - CRIAÇÃO DE TEMA DE REDAÇÃO
        </ModalHeader>
        <ModalBody className="p-0">
          <Document>
            <SubTitle>Tema proposto: {formData.nome} </SubTitle>
            <Paragraph>
              Esta é uma pré-visualização das informações vinculadas à proposta
              de Tema de Redação.
            </Paragraph>
            <h2>Instruções:</h2>
            <UnorderedList>
              {formData.instrucoesSelecionadas.map((instrucao) => (
                <>
                  <li key={instrucao}>
                    {
                      formData.instrucoes.find(
                        (inst) => inst.value === instrucao
                      ).label
                    }
                  </li>
                </>
              ))}
            </UnorderedList>
            <h2>Não será analisada a produção textual que:</h2>
            <UnorderedList>
              {formData.criteriosSelecionados.map((criterio) => (
                <>
                  <li key={criterio}>
                    {
                      formData.criterios.find((crit) => crit.value === criterio)
                        .label
                    }
                  </li>
                </>
              ))}
            </UnorderedList>
            {formData.textoMotivador.map((texto, index) => {
              return (
                <>
                  <h2>Texto motivador {index + 1}: </h2>
                  <div
                    className="html-container"
                    dangerouslySetInnerHTML={{ __html: texto.texto }}
                  />
                </>
              );
            })}
            <HorizontalLine />
            <SubTitle>PROPOSTA DE REDAÇÃO</SubTitle>
            <div
              className="html-container"
              dangerouslySetInnerHTML={{ __html: formData.proposta_de_texto }}
            />
          </Document>
        </ModalBody>
        <ModalFooter
          style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
        >
          <ButtonPadrao
            onClick={() =>
              setFormData((prevState) => ({ ...prevState, isModalOpen: false }))
            }
          >
            Fechar pré-vizualização
          </ButtonPadrao>
        </ModalFooter>
      </Modal>
    );
  };

  let contTextN = 0;

  return (
    <DivFather>
      <DivConteiner>
        <FormContainer>
          <DivHeaderForm>
            <SpanTitle>
              Escolha a fase e o gênero para os quais o tema da redação é
              direcionado
            </SpanTitle>
            <DivSelectForm>
              <InputSelect
                key={formData.periodo.id}
                label="Série/Ano Escolar"
                col="col-md-4"
                field="periodo"
                options={formData.periodo}
                onChange={(e) => handleChangeInputs(e, 'periodoSelecionado')}
              />
              <InputSelect
                key={formData.tipoOption.id}
                label="Tipo"
                col="col-md-4"
                field="tipoOption"
                options={formData.tipoOption}
                onChange={(e) => {
                  handleChangeInputs(e, 'tipoSelecionado');
                  fetchGenero(e);
                }}
              />
              <InputSelect
                key={formData.genero.id}
                label="Gênero"
                col="col-md-4"
                field="genero"
                options={formData.genero}
                onChange={(e) => handleChangeInputs(e, 'generoSelecionado')}
                onFocus={() => handleGenero()}
              />
            </DivSelectForm>
          </DivHeaderForm>
          <DivBody>
            <DivCheckbox>
              <div
                style={{
                  marginTop: 20,
                  marginLeft: 20,
                  marginRight: 20,
                  marginBottom: 10
                }}
              >
                <div style={{ marginLeft: '20px' }}>
                  <input
                    name="isTemaRedacaoEnabled"
                    type="checkbox"
                    id="temaRedacao"
                    checked={formData.isTemaRedacaoEnabled}
                    onChange={() =>
                      setFormData((prevState) => ({
                        ...prevState,
                        isTemaRedacaoEnabled: !formData.isTemaRedacaoEnabled
                      }))
                    }
                    style={{ marginRight: '5px' }}
                  />
                  <label htmlFor="temaRedacao" style={{ color: '#727780' }}>
                    Deseja escolher o tema da redação?{' '}
                  </label>
                </div>
                {formData.isTemaRedacaoEnabled && (
                  <InputText
                    label="Tema"
                    field="nome"
                    col="col-md-12"
                    value={formData.nome}
                    onChange={(e) => handleChangeInputs(e, 'nome')}
                  />
                )}
              </div>
              <DivGenero>
                <InputSelect
                  label="Número de textos motivadores"
                  col="col-md-4"
                  field="numeroTextosMotivadoresSelecionado"
                  options={formData.numeroTextosMotivadores}
                  onChange={(e) =>
                    handleChangeInputs(e, 'numeroTextosMotivadoresSelecionado')
                  }
                />
                <InputNumber
                  label="Número mínimo de caracteres"
                  field="numeroMinimoCaracteres"
                  col="col-md-4"
                  value={formData.numeroMinimoCaracteres}
                  onChange={(e) =>
                    handleChangeInputs(e, 'numeroMinimoCaracteres')
                  }
                />
              </DivGenero>
              <DivGenero>
                <InputCheckBox
                  label="Instruções"
                  field="instrucoes"
                  options={formData.instrucoes}
                  onChange={(e) =>
                    handleChangeInputCheckbox(
                      parseInt(e.target.value),
                      'instrucoesSelecionadas'
                    )
                  }
                />
              </DivGenero>
              <DivGenero>
                <InputCheckBox
                  label="Critérios de avaliação"
                  field="criterios"
                  options={formData.criterios}
                  onChange={(e) =>
                    handleChangeInputCheckbox(
                      parseInt(e.target.value),
                      'criteriosSelecionados'
                    )
                  }
                />
              </DivGenero>
            </DivCheckbox>
            <HorizontalLine />
            {formData.textoMotivador.map((textoMotivador) => {
              if (textoMotivador.active) {
                contTextN++;
              }
              return (
                <React.Fragment key={textoMotivador.id}>
                  <InputSummernote
                    col="col-sm-12"
                    label={'Texto Motivador ' + contTextN}
                    field={'texto_motivador_' + textoMotivador.id}
                    value={textoMotivador.texto}
                    onChange={(e) =>
                      handleChangeTextoMotivador(e, textoMotivador.id)
                    }
                  />
                  <DivButtonDelete>
                    <ButtonDelete
                      onClick={() =>
                        handleDeleteTextoMotivador(textoMotivador.id)
                      }
                    >
                      Excluir
                    </ButtonDelete>
                  </DivButtonDelete>
                </React.Fragment>
              );
            })}

            {formData.textoMotivador.length > 0 && (
              <DivButton onClick={(e) => handleAddTextoMotivador(e)}>
                + Adicionar texto motivador
              </DivButton>
            )}
            <HorizontalLine />
            {formData.proposta_de_texto && (
              <InputSummernote
                col="col-sm-12"
                label="Proposta de Redação"
                field="proposta_de_texto"
                value={formData.proposta_de_texto}
                onChange={(e) => handleChangeInputs(e, 'proposta_de_texto')}
              />
            )}
          </DivBody>
          <DivButtonPreVisualizar>
            <ButtonPreVisualizar
              onClick={() =>
                setFormData((prevState) => ({
                  ...prevState,
                  isModalOpen: true
                }))
              }
            >
              <VisibilityIcon /> Pré-Visualizar Tema
            </ButtonPreVisualizar>
          </DivButtonPreVisualizar>
          <DivButtonSalvar>
            <ButtonCancelar
              disabled={formData.fetchGerandoTema}
              onClick={() => handleCancel()}
            >
              Cancelar
            </ButtonCancelar>
            <ButtonGerar
              disabled={formData.fetchGerandoTema}
              onClick={() => handleGerarTema()}
            >
              {' '}
              {formData.fetchGerandoTema ? 'Gerando Tema...' : 'Gerar Tema'}
            </ButtonGerar>
            <ButtonPadrao
              disabled={!(formData.temaGerado && !formData.fetchGerandoTema)}
              onClick={() => handleCriarTema()}
            >
              Criar tema
            </ButtonPadrao>
          </DivButtonSalvar>
        </FormContainer>
      </DivConteiner>
      {formData.isModalOpen && createModal()}
    </DivFather>
  );
};

export default CreateRedacaoIA;
